import "./chunk-QZ7TP4HQ.mjs";

// src/scroll-area.anatomy.ts
import { createAnatomy } from "@zag-js/anatomy";
var anatomy = createAnatomy("scroll-area").parts("root", "viewport", "content", "scrollbar", "thumb", "corner");
var parts = anatomy.build();
export {
  anatomy,
  parts
};
